import { useAuth } from 'context/auth-context';
import { routes } from 'router';
import { useUserData } from "store/user-data";
import { toast } from "sonner";

export function useSessionControl() {
    const { logout } = useAuth();

    function sessionControl(statusCode: number) {
        if (statusCode === 401) {
            window.location.href = routes.Login.path;
            useUserData.getState().deleteUserData();
            logout();
            toast.message("Your session has expired");
        }
    }

    return { sessionControl };
}
